import React, { useEffect, useState } from "react";
import { Col, MessageBlock, Row, Section } from "mta-rkvr-styles";
import { useTranslation } from "react-i18next";
import InterestMessages from "./InterestMessages";
import { get } from "../api/fetch";
import { Alert, AlertsResponseBody } from "../types/admin/Alerts";
import flags from "../static/flags.png";
const HomePageUnauth: React.FC<{
  userMissing?: { current: boolean };
}> = ({ userMissing }) => {
  const { t } = useTranslation();

  const [alerts, setAlerts] = useState<Alert[]>();

  useEffect(() => {
    get<AlertsResponseBody>({
      endPoint: "alerts",
      queryParams: [{ name: "showActive", value: "true" }],
    }).then((res) => res.ok && setAlerts(res.body.resultsList));
  }, []);

  let userMissingPart;
  if (userMissing?.current == true) {
    userMissingPart = <MessageBlock theme="warning" messages={[t("homePage.userMissing")]} />;
  }

  return (
    <>
      {userMissingPart}
      <Section title={"Riigi kinnisvararegister"}>
        <Row>
          <Col lg={14} xl={16}>
            <p>{t("homePage.introduction")}</p>
            <p>{t("homePage.commonFunctions.introduction")}</p>
            <ul>
              <li>{t("homePage.commonFunctions.option1")}</li>
              <li>{t("homePage.commonFunctions.option2")}</li>
            </ul>
            <p>{t("homePage.authorizedFunctions.introduction")}</p>
            <ul>
              <li>{t("homePage.authorizedFunctions.option2")}</li>
              <li>{t("homePage.authorizedFunctions.option3")}</li>
              <li>{t("homePage.authorizedFunctions.option4")}</li>
              <li>{t("homePage.authorizedFunctions.option1")}</li>
            </ul>
            <p>
              {`${t("homePage.legalBase")}: `}
              <a href="https://riigivara.kataster.ee/">https://riigivara.kataster.ee/</a>
            </p>
          </Col>
          <Col lg={6} xl={4}>
            <img alt="Euroopa regionaalarengu fondi logo" style={{ margin: "0 auto", display: "block" }} src={flags} />
          </Col>
        </Row>
      </Section>
      {alerts?.map((alert) => (
        <MessageBlock key={alert.alertId} theme="warning" messages={alert.teade ? [alert.teade] : []} />
      ))}
      <Section
        title={t("homePageAuth.interestMessages.title")}
        collapsable={true}
        collapsed={false}
        withCollapseIcon={true}
      >
        <InterestMessages teateType="RVTEADE" />
        <InterestMessages teateType="KOVTEADE" />
      </Section>
    </>
  );
};

export default HomePageUnauth;
